import {
  API_METHODS
} from "../../constant";
export const reportApi = (
  _getAll,
  _get,
  paramsIn
) => {
  return {
    [API_METHODS.GET_REPORTS]: () => {
      let urlReq = `/HrFeedReport`;
      return _getAll(urlReq, paramsIn);
    }
  };
};
